export default __webpack_public_path__ + "static/media/no-logo.40ad623d.png";